export default class NumbersOnlyDirective {
    constructor() {
        this.restrict = 'A';
        this.require = 'ngModel';
    }

    link(scope, element, attrs, ngModelCtrl) {
        function fromUser(text) {
            if (text) {
                let transformedInput = text.replace(/[^0-9]/g, '');

                if (transformedInput !== text) {
                    ngModelCtrl.$setViewValue(transformedInput);
                    ngModelCtrl.$render();
                }
                return transformedInput;
            }
            return undefined;
        }

        ngModelCtrl.$parsers.push(fromUser);
    }

    static directiveFactory() {
        'ngInject';

        return new NumbersOnlyDirective();
    }
}
